import { render, staticRenderFns } from "./ProblemModal.vue.js?vue&type=template&id=b5afa204!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProblemModal.vue?vue&type=template&id=b5afa204"
import script from "./ProblemModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProblemModal.vue?vue&type=script&lang=js"
export * from "./ProblemModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProblemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports